import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';

export interface PagadorTesteDTO {
  cpf: string;
  nomeCompleto: string;
  email: string;
  telefone?: string;
  logradouro: string;
  numero: string;
  complemento?: string;
  cep: string;
  bairro: string;
  cidade: string;
  uf: string;
}

export interface TesteBoletoCreateRequest {
  orgaoId: number;
  dataVencimento: string;
  valor: number;
  /** ID do pagador cadastrado (prioridade se informado) */
  pagadorTesteId?: number;
  /** Dados do pagador inline (usado se pagadorTesteId não informado) */
  pagador?: PagadorTesteDTO;
}

export interface TesteBoletoUpdateRequest {
  dataVencimento?: string;
  valor?: number;
}

export interface TesteBoletoResponse {
  id: number;
  orgaoId: number;
  dataVencimento: string;
  valor: number;
  status: string;
  nossoNumero: string | null;
  linhaDigitavel: string | null;
  codigoBarras: string | null;
  qrCodePix: string | null;
  urlImagem: string | null;
  dataRegistroBb: string | null;
  dataLiquidacao: string | null;
  valorPago: number | null;
  createdAt: string;
  updatedAt: string;
}

@Injectable({
  providedIn: 'root'
})
export class BoletosTesteService {
  private baseUrl = `${environment.apiUrl}/admin/boletos-teste`;

  constructor(private http: HttpClient) {}

  criar(request: TesteBoletoCreateRequest): Observable<TesteBoletoResponse> {
    console.log(request);
    return this.http.post<TesteBoletoResponse>(this.baseUrl, request);
  }

  atualizar(id: number, request: TesteBoletoUpdateRequest): Observable<TesteBoletoResponse> {
    return this.http.put<TesteBoletoResponse>(`${this.baseUrl}/${id}`, request);
  }

  sincronizarStatus(id: number): Observable<TesteBoletoResponse> {
    return this.http.post<TesteBoletoResponse>(`${this.baseUrl}/${id}/sync`, {});
  }

  remover(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  buscarPorId(id: number): Observable<TesteBoletoResponse> {
    return this.http.get<TesteBoletoResponse>(`${this.baseUrl}/${id}`);
  }

  listar(): Observable<TesteBoletoResponse[]> {
    return this.http.get<TesteBoletoResponse[]>(this.baseUrl);
  }
}
